import { LOCAL_STORAGE_AUTH_STATE, ROLES } from 'src/constants/auth';

import { initialState } from '.';

export type PayloadProps = {
  token?: string;
  user?: User;
  isRefresh?: boolean;
  error?: string;
};

export const setLoginInformation = (state: IAuthState): void => {
  window.localStorage.setItem(LOCAL_STORAGE_AUTH_STATE, JSON.stringify(state));
};

export function removeLoginInformation() {
  window.localStorage.removeItem(LOCAL_STORAGE_AUTH_STATE);
}

export function removeUserLoginInformation(state: IAuthState) {
  window.localStorage.setItem(
    LOCAL_STORAGE_AUTH_STATE,
    JSON.stringify({
      ...state,
      currentUser: undefined,
      currentAccount: undefined,
      currentUserToken: undefined,
      metadataRequested: false,
    })
  );
}

export const getFromStorage = (key: string) => {
  try {
    // @ts-ignore
    return JSON.parse(window.localStorage.getItem(key)) || initialState;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return initialState;
  }
};

const getUserRole = (user: User): number => user.role.id;

export const setAuthStateBasedOnRole = (state: IAuthState, payload?: PayloadProps): IAuthState => {
  if (payload?.user) {
    const role = getUserRole(payload.user);
    if (role === ROLES.SUPER_ADMIN) {
      if (payload?.isRefresh) {
        return {
          ...state,
          superAdminToken: payload.token,
        };
      } else {
        return {
          ...initialState,
          superAdminToken: payload.token,
          superAdminUser: payload.user,
          currentUserToken: '',
          currentUser: undefined,
          currentAccount: undefined,
        };
      }
    } else {
      if (payload?.isRefresh) {
        return {
          ...state,
          currentUserToken: payload.token,
        };
      } else {
        return {
          ...initialState,
          superAdminToken: '',
          superAdminUser: undefined,
          currentUserToken: payload.token,
          currentUser: payload.user,
          role: payload.user.role.id,
        };
      }
    }
  } else {
    return state;
  }
};

export const setUserTokenFn = (state: IAuthState, payload?: PayloadProps) => ({
  ...state,
  currentUserToken: payload?.token,
  currentUser: payload?.user,
});

export const logoutFromUserFn = (state: IAuthState) => ({
  ...state,
  currentUserToken: '',
  currentUser: undefined,
  currentAccount: undefined,
  accountsSearchValue: '',
});
